import { useRef, useEffect, useState } from 'react';
import { FaWhatsapp } from "react-icons/fa";

const Nav = ({ onLinkClick }) => {

  const [isScrolled, setIsScrolled] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 550;

      setIsScrolled((prev) => (prev !== scrolled ? scrolled : prev));
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [])

  useEffect(() => {
    if (containerRef.current) {
      const spanElement = document.createElement('span');
      spanElement.className = 'menu-trigger';
      spanElement.innerHTML = '<i class="fal fa-angle-down"></i>';
      containerRef.current.appendChild(spanElement);
    }
  }, []);

  const [menuItems, setMenuItems] = useState([
    {
      label: 'Beranda',
      link: '/',
    },
    {
      label: 'Instruktur',
      link: '/instructor',
    },
    {
      label: 'Kursus',
      link: '/course',
      // submenu: [
      //     { label: 'General English', link: '#courses' },
      //     { label: 'IELTS', link: '#ielts' },
      //     { label: 'TOEFL', link: '#toefl' },
      //     { label: 'Duolingo', link: '#duolingo' },
      //     { label: 'iPass', link: '#ipass' },
      //   ],
    },
    {
      label: 'Event',
      link: '/event',

    },
    {
      label: 'Fasilitas Belajar',
      link: '/learning-space',

    },
    {
      label: 'Kontak',
      link: '#footer',

    },


    // Add more menu items as needed
  ]);
  useEffect(() => {
    setMenuItems((prevMenuItems) =>
      prevMenuItems.map((item) =>
        item.submenu && item.submenu.length > 0
          ? { ...item, hasSubmenu: true }
          : item
      )
    );
  }, []);

  const handleSubmenuToggle = (index) => {
    setMenuItems((prevMenuItems) => {
      const newMenuItems = [...prevMenuItems];
      newMenuItems[index].submenuOpen = !newMenuItems[index].submenuOpen;
      return newMenuItems;
    });
  };

  return (

    <ul className="primary-menu">
      {menuItems.map((item, index) => (
        <li key={index}>

          <a href={item.link} onClick={onLinkClick}>
            {item.label}
          </a>

          {item.submenu && (
            <span
              className={`menu-trigger ${item.submenuOpen ? 'open' : ' '}`}
              onClick={() => handleSubmenuToggle(index)}
            >

              <i
                className={`submenu-icon ${item.submenuOpen ? 'fal fa-angle-up' : 'fal fa-angle-down'}`}>
              </i>
            </span>
          )}
          {item.submenu && (
            <ul className={`submenu ${item.submenuOpen ? 'open' : ''}`}

            >
              {item.submenu.map((subitem, subindex) => (
                <li key={subindex} >
                  <a href={subitem.link} onClick={onLinkClick}>{subitem.label}</a>
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
      <a
        href="https://wa.me/6281238431234"
        target="_blank"
        className={`btn btn-sm btn-main rounded wa-cta ${isScrolled ? "wa-show" : "wa-hide"
          }`}
      >
        <div className='d-flex align-items-center'>
          <FaWhatsapp className='me-2' />Konsultasi Gratis
        </div>
      </a>
    </ul>

  )
}
export default Nav;
